import { ReduxBaseAction } from '../../domain/redux/ReduxBaseAction';
import { ListVariable } from '../../domain/enrichment/EnrichmentDomain';
import { ListVariableSchema } from '../../domain/enrichment/EnrichmentSchemaDomains';

export type ListVariableActions =
  | 'CHANGE_LIST_VARIABLE'
  | 'CHANGE_LIST_VARIABLE_SCHEMA'
  | 'CHANGE_LIST_VARIABLE_IS_UPDATE'
  | 'CLEAR_LIST_VARIABLE'
  | 'CHANGE_LIST_VARIABLE_DIRTY';

export const changeListVariable = (payload: ListVariable) =>
  ({
    type: 'CHANGE_LIST_VARIABLE',
    payload,
  }) as ReduxBaseAction<ListVariable | null, ListVariableActions>;

export const changeListVariableSchema = (payload: ListVariableSchema | null) =>
  ({
    type: 'CHANGE_LIST_VARIABLE_SCHEMA',
    payload,
  }) as ReduxBaseAction<ListVariableSchema | null, ListVariableActions>;

export const changeListVariableIsUpdate = (payload: boolean) =>
  ({
    type: 'CHANGE_LIST_VARIABLE_IS_UPDATE',
    payload,
  }) as ReduxBaseAction<boolean, ListVariableActions>;

export const clearListVariable = () =>
  ({
    type: 'CLEAR_LIST_VARIABLE',
    payload: void 0,
  }) as ReduxBaseAction<any, ListVariableActions>;

export const changeListVariableDirty = (payload: boolean) =>
  ({
    type: 'CHANGE_LIST_VARIABLE_DIRTY',
    payload,
  }) as ReduxBaseAction<any, ListVariableActions>;
